import { graphql } from 'relay-runtime';

export const getStudentRoadmapOverall = graphql`
  query IndividualStudentReportRoadmapOverallQuery($studentId: ID!, $roadmapId: ID!) {
    skillStatesByStudentId(studentId: $studentId, filter: { targetGroupId: $roadmapId }) {
      id
      skill {
        id
        code
        name
        targetSkills(filter: { targetGroupIds: [$roadmapId] }) {
          id
          targetSkillType {
            id
            name
          }
        }
      }
      skillSubstate {
        id
        name
        skillState {
          id
          name
        }
      }
      skillAssessment(showCurrentYearAssessmentsOnly: true) {
        score
        id
      }
    }
  }
`;

export const getUserTimePlataform = graphql`
  query IndividualStudentReportUserTimeQuery($date: DateTime!, $userId: ID!) {
    getUserTimeOnPlatform(date: $date, userId: $userId) {
      totalMinutes
    }
  }
`;

export const getOverallProjection = graphql`
  query IndividualStudentReportOverallQuery($userId: ID!) {
    IndividualReportOverview(userId: $userId) {
      diagnosticDate
      demonstratedSkillsInDiagnostic
      demonstratedSkillsSinceDiagnostic
      roadmapSkills
      studentWillCompleteDate
      currentPace
      projectedStatusCurrentPace
      projectedStatusTwoSkillsPace
      projectedPercentageTwoSkillsPace
      projectedStatusThreeSkillsPace
      projectedPercentageThreeSkillsPace
      projectedStatusFourSkillsPace
      projectedPercentageFourSkillsPace
      projectedPercentageCurrentPace
    }
  }
`;

export const getPdfIndividualStudent = graphql`
  query IndividualStudentReportPdfQuery($input: DownloadIndividualStudentReportInput!, $skip: Boolean!) {
    generateIndividualStudentReportPDFs(downloadIndividualStudentReportInput: $input) @skip(if: $skip) {
      base64Data
      fileName
    }
  }
`;

export const getDataFromIndividualReport = graphql`
  query IndividualStudentReportDataQuery($studentId: ID!, $id: ID!, $filter: AllStudentsFilterInput!, $skip: Boolean!) {
    latestCompletedStudentSkillDiagnostic(studentId: $studentId) {
      id
      isInferred
      retakeAssigned
    }

    currentTargetGroupByStudentId(studentId: $id) {
      targetGroup {
        id
        name
      }
    }

    studentById(studentId: $id) {
      firstName
      lastName
      id
      publicUserId
      sites {
        id
      }
      userClasses {
        id
        isActive
        class {
          id
          name
          section
        }
      }
    }

    allStudents(filter: $filter, first: 1000) @skip(if: $skip) {
      nodes {
        id
        firstName
        lastName
        publicUserId
      }
    }
  }
`;

export const getLatestDignosticStudentReport = graphql`
  query IndividualStudentReportDiagnosticQuery($studentId: ID!) {
    latestCompletedStudentSkillDiagnostic(studentId: $studentId) {
      id
      isInferred
      retakeAssigned
    }
  }
`;

export const getSkillAssessmentsByStudentId = graphql`
  query IndividualStudentReportAssessmentsQuery($studentId: ID!, $filter: SkillAssessmentsByStudentFilterInput!) {
    skillAssessmentsByStudentId(studentId: $studentId, filter: $filter) {
      nodes {
        id
        score
        sessionLength
        sessionCompletedOn
        sessionId
        activityId
        publicUserId
        items {
          id
          duration
        }
        skill {
          id
          name
        }
      }
    }
  }
`;

export const getLearnosityInitObjectIndividualReport = graphql`
  query IndividualStudentReportInitObjectQuery($initModel: LearnosityInitObjectInput!, $skip: Boolean!) {
    getLearnosityInitObject(initModel: $initModel) @skip(if: $skip)
  }
`;

export const getStudentAssessmentsIndividualReport = graphql`
  query IndividualStudentReportAssessmentsTableQuery($filter: StudentsSkillAssessmentsFilterInput!) {
    studentsSkillAssessments(filter: $filter) {
      nodes {
        id
        skill {
          id
          name
        }
      }
    }
  }
`;

export const getStudentReportStatsAndSkillsWeekly = graphql`
  query IndividualStudentReportStatsQuery(
    $userId: ID!
    $from: DateTime!
    $to: DateTime!
    $siteIds: [ID!]
    $classExitSlipsFilter: ClassExitSlipsFilterInput
  ) {
    siteSchoolYears(filterInput: { siteIds: $siteIds }) {
      id
      startOn
    }
    individualReportPerformanceStats(userId: $userId, fromDate: $from, toDate: $to) {
      logins
      skillsWorkedOn
      demonstratedSkillsPassed
      demonstratedSkillsInferred
      platformTime
    }
    individualReportDailyActivity(fromDate: $from, toDate: $to, userId: $userId) {
      day
      dailyActivitySkills {
        skillInferredSkills {
          isTargetSkill
          name
          code
        }
        skillId
        isTargetSkill
        name
        code
        practiceProblemTime
        exampleVideoTime
        skillChallengesTime
        skillAssessments {
          score
          attemptNumber
          sessionId
        }
      }
    }
    classExitSlips(filter: $classExitSlipsFilter) {
      id
      dueOn
      curriculumLesson {
        id
        number
        name
        target {
          name
        }
      }
      learnosityExitSlipSessions(learnosityExitSlipSessionsFilter: { userIds: [$userId] }) {
        activityId
        sessionId
        publicUserId
        sessionLength
        sessionCompletedOn
        isComplete
        score
        items {
          id
          score
          maxScore
          questionNumber
          attempted
          itemReference
        }
      }
    }
  }
`;
